var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

    var lang = UpAct.lang;
    var cfg = actInfo.overallRanking;
    var time = UpAct.TimeUtil.getActTimeWithDate(cfg.startTime*1000,cfg.endTime*1000,UpAct.lang.lang)

__p+='\n<div class="app-page shouhu">\n	<div class="back gohome" >'+
((__t=(lang.template('返回')))==null?'':__t)+
'</div>\n    <div class="header">\n        <div class="act-time">'+
((__t=(lang.template('活动时间:{time}',{time: time})))==null?'':__t)+
'</div>\n    </div>\n    \n    <div class="page-content" id="page-content">\n        \n    </div>  \n\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/template/page-shouhu.tmpl
// module id = 84
// module chunks = 0